// extracted by mini-css-extract-plugin
module.exports = {"taskDetailsCell":"style_taskDetailsCell__NcVrAT5b7RrOeEKuArAdZ","blockIcon":"style_blockIcon__1TcBRIHubEhvXQOUosZ4jO","cell":"style_cell__5CTZSnH7HufQrSAhZpWxr"};